import { produce } from 'immer';
import { extractError } from 'app/lib/error';
import type {
    DeleteGithubAuthenticationFailure,
    GetGithubAuthenticationInfoFailure,
    GithubAuthenticationInfo,
    SetGithubAuthenticationFailure
} from 'app/lib/types/server';
import {
    GET_GITHUB_AUTHENTICATION_INFO_ACTION_TYPE,
    SET_GITHUB_AUTHENTICATION_ACTION_TYPE,
    DELETE_GITHUB_AUTHENTICATION_ACTION_TYPE
} from './types';
import type { GithubActionOutcomes } from './actions';

export type GithubStateSlice = {
    authInfo: null | GithubAuthenticationInfo;
    isLoading: boolean;
    error:
        | null
        | SetGithubAuthenticationFailure
        | GetGithubAuthenticationInfoFailure
        | DeleteGithubAuthenticationFailure;
};

export const INITIAL_STATE: GithubStateSlice = {
    isLoading: false,
    authInfo: null,
    error: null
};

export const githubReducer = produce((draft, action: GithubActionOutcomes) => {
    switch (action.type) {
        case SET_GITHUB_AUTHENTICATION_ACTION_TYPE.STARTED:
        case GET_GITHUB_AUTHENTICATION_INFO_ACTION_TYPE.STARTED:
        case DELETE_GITHUB_AUTHENTICATION_ACTION_TYPE.STARTED: {
            draft.error = null;
            draft.error = null;
            draft.isLoading = true;
            break;
        }
        case SET_GITHUB_AUTHENTICATION_ACTION_TYPE.FAILED:
        case GET_GITHUB_AUTHENTICATION_INFO_ACTION_TYPE.FAILED:
        case DELETE_GITHUB_AUTHENTICATION_ACTION_TYPE.FAILED: {
            draft.error = extractError(action.payload);
            break;
        }
        case GET_GITHUB_AUTHENTICATION_INFO_ACTION_TYPE.SUCCEEDED: {
            draft.authInfo = action.payload;
            draft.isLoading = false;
            break;
        }
        case SET_GITHUB_AUTHENTICATION_ACTION_TYPE.SUCCEEDED: {
            draft.isLoading = false;
            break;
        }
        case DELETE_GITHUB_AUTHENTICATION_ACTION_TYPE.SUCCEEDED: {
            draft.authInfo = null;
            draft.error = null;
            draft.isLoading = false;
            break;
        }
        default:
            break;
    }
}, INITIAL_STATE);
